package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolConfigListItemResponse(
    @SerialName("id") val id: String? = null,
    // Newer backend responses may expose this explicitly; retain id for compatibility
    // with the current school-list response.
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("name") val name: String? = null,
    @SerialName("code") val code: String? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    // Legacy list fields — ignored by the current School Configuration UI.
    @SerialName("board") val board: String? = null,
    @SerialName("medium") val medium: String? = null
)
